module.exports = __webpack_public_path__ + "img/stok1.f860236f.jpg";